import React, { useEffect, useMemo, useRef, useState } from 'react';
import { profileAvatar } from '../component/ImageList';
import baseURL from '../component/baseURL';
import { useNavigate } from 'react-router-dom';
import showNotification from '../component/Notification';
import stringsoflanguages from '../component/stringsoflanguages';

export default function NewAvailable() {
    const navigate = useNavigate();
    const [newAvailable, setNewAvailable] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [actionLoadingId, setActionLoadingId] = useState('');
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(false);
    const [gearMenuOpen, setGearMenuOpen] = useState(false);
    const [gearSpinning, setGearSpinning] = useState(false);
    const gearMenuRef = useRef(null);

    useEffect(() => {
        const userID = localStorage.getItem('user_id');
        fetchNewAvailable(userID, true);
    }, []);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 767);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (!gearMenuRef.current?.contains(event.target)) {
                setGearMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutsideClick);
        return () => document.removeEventListener('mousedown', handleOutsideClick);
    }, []);

    function fetchNewAvailable(userID, showPageLoader = false) {
        if (showPageLoader) {
            setLoading(true);
        }
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055")
        fetch(baseURL.URL + '/portfolio_feed/fetch_available_listings', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server && responseJson.server.code === 200) {
                    const list = responseJson.response?.result ?? [];
                    setNewAvailable(Array.isArray(list) ? list : []);
                } else {
                    setNewAvailable([]);
                    if (responseJson.server?.message) console.error(responseJson.server.message);
                }
            })
            .catch((error) => {
                setNewAvailable([]);
                console.error(error);
            })
            .finally(() => {
                if (showPageLoader) {
                    setLoading(false);
                }
            });
    }

    function handleAcceptIndexChange(index, listingId, requestId) {
        const nextValue = String(index) === '2' ? 2 : String(index) === '1' ? 1 : 0;
        acceptDeclineFeed(nextValue, listingId, requestId);
    }


    function acceptDeclineFeed(isAccept, listingId, requestId) {
        const userID = localStorage.getItem('user_id');
        if (!userID || !requestId) return;
        setActionLoadingId(String(requestId));
        let formdata = new FormData();
        formdata.append('user_id', userID);
        formdata.append('response_type', String(isAccept));
        formdata.append('request_id', requestId);
        formdata.append('listing_id', listingId ?? '');
        formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
        fetch(baseURL.URL + '/portfolio_feed/accept_decline_feed_shared_single', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    showNotification('Success', responseJson.server?.message || 'Updated successfully', 'success');
                } else {
                    showNotification('Error', responseJson.server?.message || 'Action failed', 'danger');
                }
                fetchNewAvailable(userID);
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Action failed', 'danger');
            })
            .finally(() => {
                setActionLoadingId('');
            });
    }

    function publishUnpublishFeed(nextValue, listingId) {
        const userID = localStorage.getItem('user_id');
        if (!userID || !listingId) return;
        setActionLoadingId(String(listingId));
        const formdata = new FormData();
        formdata.append('user_id', userID);
        formdata.append('is_published', String(nextValue));
        formdata.append('listing_id', String(listingId));
        formdata.append('key', '81dc9bdb52d04dc20036dbd8313ed055');
        fetch(baseURL.URL + '/portfolio_feed/publish_unpublish_feed_shared', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    showNotification('Success', responseJson.server?.message || 'Updated successfully', 'success');
                } else {
                    showNotification('Error', responseJson.server?.message || 'Action failed', 'danger');
                }
                fetchNewAvailable(userID);
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Action failed', 'danger');
            })
            .finally(() => {
                setActionLoadingId('');
            });
    }

    function handlePublishIndexChange(index, listingId, requestId) {
        const nextValue = String(index) === '2' ? 2 : String(index) === '1' ? 1 : 0;
        publishUnbublishFeed(nextValue, listingId, requestId);
    }

    function publishUnbublishFeed(isPublished, listingId, requestId) {
        const userID = localStorage.getItem('user_id');
        if (!userID || !listingId) return;
        setActionLoadingId(String(listingId));
        let formdata = new FormData();
        formdata.append("user_id", userID);
        formdata.append("is_published", String(isPublished));
        formdata.append("request_id", requestId ?? '');
        formdata.append("listing_id", listingId);
        formdata.append("key", "81dc9bdb52d04dc20036dbd8313ed055");
        fetch(baseURL.URL + '/portfolio_feed/publish_unpublish_feed_shared', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                if (responseJson.server?.code === 200) {
                    showNotification('Success', responseJson.server?.message || 'Updated successfully', 'success');
                } else {
                    showNotification('Error', responseJson.server?.message || 'Action failed', 'danger');
                }
                fetchNewAvailable(userID);
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Action failed', 'danger');
            })
            .finally(() => {
                setActionLoadingId('');
            });
    }

    const filteredListings = useMemo(() => {
        const q = searchQuery.trim().toLowerCase();
        if (!q) return newAvailable;
        return newAvailable.filter((listing) => {
            const agent = listing.agent_details ?? {};
            const haystack = [
                listing.ListingId,
                listing.StandardStatus,
                listing.StandardStatusName,
                listing.PublicRemarks,
                listing.StreetNumber,
                listing.StreetName,
                listing.city_name,
                listing.state_name,
                listing.country_name,
                listing.PostalCode,
                listing.ListPrice,
                agent.fname,
                agent.lname
            ]
                .filter((v) => v !== null && v !== undefined)
                .map((v) => String(v).toLowerCase())
                .join(' ');
            return haystack.includes(q);
        });
    }, [newAvailable, searchQuery]);


    if (loading) {
        return (
            <div className="content-right page-loader-wrapper">
                <div className="react-js-loader">
                    <div className="react-js-loader-spinner"></div>
                    <p className="react-js-loader-text">{stringsoflanguages.loading}</p>
                </div>
            </div>
        );
    }

    return (
        <div className={`content-right ${isMobile ? 'feed-recived-page-mobile' : ''}`}>
            {isMobile && (
                <div className="mobile-page-header">
                    <button type="button" className="mobile-back-btn" onClick={() => navigate('/feed')} aria-label="Back">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <h2 className="mobile-page-title">{stringsoflanguages.newAvailable}</h2>
                </div>
            )}
            {/* Search and Filter Section */}
            <div className="search-filter-section">
                <div className="search-bar">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        className="search-icon"
                    >
                        <path
                            d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M17.5 17.5L13.875 13.875"
                            stroke="#E1730B"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                    <input
                        type="text"
                        placeholder="Search by name / company"
                        className="search-input"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
            </div>

            <div className="my-listings-cards-grid new-available-listings">
                <div className="property-grid">

                    {filteredListings.length === 0 ? (
                        <p className="no-data-message">{searchQuery.trim() ? 'No listings match your search.' : 'No listings found.'}</p>
                    ) : (
                        filteredListings.map((listing, index) => {
                            const id = listing.listing_id ?? index;
                            const image = listing.image ?? 'https://placehold.co/600x400';
                            const title = [listing.PostalCode, listing.city_name].filter(Boolean).join(', ').trim() || '—';
                            const propertyType = listing.PropertyType ?? 'Property Type';
                            const streetPart = [listing.StreetNumber, listing.StreetName].filter(Boolean).join(' ').trim();
                            const cityParts = [listing.city_name, listing.state_name, listing.PostalCode, listing.country_name].filter(Boolean);
                            const cityPart = cityParts.join(', ').trim();
                            const address = streetPart ? (cityPart ? `${streetPart}, ${cityPart}` : streetPart) : (cityPart || '—');
                            const areaValue = listing.LivingArea ?? listing.LotSizeArea ?? null;
                            const rawUnit = listing.LivingAreaUnits ?? listing.LotSizeUnits ?? 'Sq Feet';
                            const areaUnitDisplay = /meter|metre/i.test(String(rawUnit)) ? 'm²' : 'f²';
                            const area = areaValue != null && areaValue !== '' ? `${areaValue} ${areaUnitDisplay}` : '—';
                            const bedrooms = listing.BedroomsTotal ?? '—';
                            const bathrooms = listing.BathroomsTotalInteger ?? '—';
                            const parking = listing.ParkingTotal ?? listing.GarageSpaces ?? '—';
                            const price = listing.ListPrice ?? '—';
                            const status = (listing.StandardStatus ?? listing.StandardStatusName) || '—';
                            const agentDetails = listing.agent_details ?? {};
                            const agent = {
                                avatar: agentDetails.picture_thumb ?? agentDetails.picture_thumb ?? agentDetails.picture ?? '',
                                name: [agentDetails.fname, agentDetails.lname].filter(Boolean).join(' ').trim() || '—'
                            };
                            const isActionLoading =
                                actionLoadingId === String(listing.request_id ?? '') ||
                                actionLoadingId === String(listing.listing_id ?? '');

                            return (
                                <div
                                    key={id}
                                    className="property-card cursor-pointer"
                                    onClick={() => navigate('/portfolio-details', {
                                        state: {
                                            listingID: listing.listing_id ?? listing.ListingId ?? id,
                                            agentID: agentDetails.agent_id ?? agentDetails.user_id ?? '',
                                            from: 'new-available'
                                        }
                                    })}
                                >

                                    <div className="property-image">
                                        <img src={image} alt="property" />
                                        {/* <div className="status">{status}</div> */}
                                        <div className="agent-info">
                                            <div className="agent-avatar">
                                                <img src={agent.avatar || 'https://placehold.co/40x40'} alt="agent" />
                                            </div>
                                            <div className="agent-name">
                                                <span>{agent.name}</span>
                                            </div>
                                        </div>
                                        <div className="status">
                                            {status === 'Active' && (
                                                <>
                                                    <span className="status-dot active"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Coming Soon' && (
                                                <>
                                                    <span className="status-dot coming-soon"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Sold' && (
                                                <>
                                                    <span className="status-dot sold"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Cancelled' && (
                                                <>
                                                    <span className="status-dot cancelled"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {status === 'Under Offer' && (
                                                <>
                                                    <span className="status-dot under-offer"></span>
                                                    <span>{status}</span>
                                                </>
                                            )}
                                            {(!status || !['Active', 'Coming Soon', 'Sold', 'Cancelled', 'Under Offer'].includes(status)) && (
                                                <>
                                                    <span className="status-dot"></span>
                                                    <span>{status || 'N/A'}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <div className="property-content">

                                        <h3 className="property-title">{title}</h3>
                                        <div className="location">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M10.0001 1.81818C6.49118 1.81818 3.63647 4.47669 3.63647 7.74444C3.63647 11.7998 9.33131 17.7533 9.57377 18.0048C9.80151 18.241 10.1991 18.2406 10.4265 18.0048C10.6689 17.7533 16.3637 11.7998 16.3637 7.74444C16.3637 4.47669 13.509 1.81818 10.0001 1.81818ZM10.0001 10.7261C8.23468 10.7261 6.79844 9.38854 6.79844 7.74444C6.79844 6.10034 8.23472 4.7628 10.0001 4.7628C11.7655 4.7628 13.2017 6.10037 13.2017 7.74447C13.2017 9.38857 11.7655 10.7261 10.0001 10.7261Z" fill="black" fillOpacity="0.35" />
                                            </svg>
                                            <span>{address}</span>
                                        </div>
                                        <div className="property-details">
                                            <div className="detail-row">
                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                                        <g clipPath="url(#clip0_405_733)">
                                                            <path d="M9.68521 11.0902L2.66029 7.27238C2.34781 7.10264 1.97881 7.10965 1.67304 7.29142C1.36727 7.47314 1.18481 7.794 1.18481 8.14972V17.0062C1.18481 17.3645 1.37832 17.6972 1.68985 17.8743L8.7149 21.868C8.86977 21.956 9.03911 22 9.20851 22C9.38112 22 9.55369 21.9543 9.71062 21.863C10.0214 21.6822 10.207 21.3595 10.207 20.9999V11.9676C10.207 11.6013 10.0071 11.2651 9.68521 11.0902Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M19.5402 4.96845C19.5397 4.59451 19.3332 4.25534 19.0012 4.08328L11.3408 0.111819C11.0507 -0.0386167 10.705 -0.0374991 10.416 0.114613L2.86825 4.08608C2.53961 4.25908 2.33519 4.59721 2.33472 4.96862C2.33429 5.33994 2.53789 5.67855 2.86606 5.85228L10.4139 9.84854C10.56 9.92587 10.7205 9.96455 10.881 9.96455C11.0396 9.96455 11.1982 9.92681 11.3429 9.8513L19.0035 5.85512C19.335 5.68216 19.5407 5.34239 19.5402 4.96845Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M20.3267 7.2914C20.0211 7.10963 19.6519 7.10245 19.3395 7.27232L12.3144 11.0902C11.9926 11.2651 11.7927 11.6013 11.7927 11.9675V20.9998C11.7927 21.3594 11.9783 21.6821 12.2891 21.8629C12.446 21.9543 12.6185 21.9999 12.7912 21.9999C12.9605 21.9999 13.13 21.9559 13.2848 21.8679L20.3099 17.8742C20.6214 17.6971 20.8149 17.3645 20.8149 17.0061V8.1497C20.8149 7.79398 20.6324 7.47313 20.3267 7.2914Z" fill="black" fillOpacity="0.35" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id={`clip0_405_733_${id}`}>
                                                                <rect width="22" height="22" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span>{area}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                        <g clipPath={`url(#clip0_405_741_${id})`}>
                                                            <path d="M2.47178 13.9166V6.1042C2.47178 5.5634 2.03338 5.125 1.49263 5.125C0.951828 5.125 0.513428 5.5634 0.513428 6.1042V18.8958C0.513428 19.4366 0.951828 19.875 1.49263 19.875C2.03338 19.875 2.47178 19.4366 2.47178 18.8958V17.0614L22.5282 17.0142V18.8487C22.5282 19.3895 22.9666 19.8279 23.5074 19.8279C24.0481 19.8279 24.4865 19.3895 24.4865 18.8487V17.0142V14.4529V13.8695L2.47178 13.9166Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M24.4865 13.0779H9.60107V9.39035C9.60107 8.3203 10.4685 7.45285 11.5386 7.45285H20.575C22.7353 7.45285 24.4865 9.20405 24.4865 11.3643V13.0779Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M6.11706 12.656C7.4373 12.656 8.50756 11.5857 8.50756 10.2655C8.50756 8.94526 7.4373 7.875 6.11706 7.875C4.79683 7.875 3.72656 8.94526 3.72656 10.2655C3.72656 11.5857 4.79683 12.656 6.11706 12.656Z" fill="black" fillOpacity="0.35" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id={`clip0_405_741_${id}`}>
                                                                <rect width="25" height="25" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span>{bedrooms}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                        <g clipPath={`url(#clip0_405_749_${id})`}>
                                                            <path d="M3.10162 23.8612C2.87721 24.1978 2.96818 24.6526 3.30475 24.8769C3.42965 24.9602 3.57076 25 3.71036 25C3.94703 25 4.17931 24.8855 4.32042 24.6737L4.87863 23.8364C4.42677 23.6381 3.99625 23.3999 3.59205 23.1255L3.10162 23.8612Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M21.4082 23.1255C21.004 23.3999 20.5735 23.6381 20.1216 23.8364L20.6798 24.6737C20.8209 24.8855 21.0531 25 21.2898 25C21.4294 25 21.5706 24.9602 21.6955 24.8769C22.0321 24.6526 22.123 24.1978 21.8986 23.8612L21.4082 23.1255Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M1.51367 14.1671V16.4551C1.51367 20.0898 4.47075 23.0469 8.10547 23.0469H16.8945C20.5292 23.0469 23.4863 20.0898 23.4863 16.4551V16.0286H11.3839C7.97895 16.0286 4.6646 15.4025 1.51367 14.1671Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M3.95483 8.63228V2.68555C3.95483 2.01245 4.50244 1.46484 5.17554 1.46484H6.1521C6.8252 1.46484 7.3728 2.01245 7.3728 2.68555V3.03306C6.24058 3.35928 5.41968 4.42187 5.41968 5.65601V5.85938C5.41968 6.26387 5.74761 6.5918 6.1521 6.5918H10.0583C10.4628 6.5918 10.7908 6.26387 10.7908 5.85938V5.61523C10.7908 4.38833 9.96348 3.35156 8.83765 3.03188V2.68555C8.83765 1.20474 7.63291 0 6.1521 0H5.17554C3.69473 0 2.48999 1.20474 2.48999 2.68555V8.04414C2.60532 8.07959 2.71919 8.12124 2.83096 8.1708C3.20249 8.33594 3.57725 8.4895 3.95483 8.63228Z" fill="black" fillOpacity="0.35" />
                                                            <path d="M23.3947 11.451H11.384C8.21198 11.451 5.13517 10.7979 2.23776 9.5101C1.45095 9.16156 0.53244 9.51469 0.183368 10.2999C-0.165705 11.0852 0.187909 12.0053 0.973211 12.3543C4.2714 13.8205 7.77375 14.5638 11.3841 14.5638H23.3948C24.2546 14.5638 24.9512 13.8671 24.9512 13.0074C24.9511 12.1476 24.2545 11.451 23.3947 11.451Z" fill="black" fillOpacity="0.35" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id={`clip0_405_749_${id}`}>
                                                                <rect width="25" height="25" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg>
                                                    <span>{bathrooms}</span>
                                                </div>
                                                <div className="detail-item">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                        <path d="M3.12492 20.5448V21.875C3.12492 22.1512 3.23467 22.4162 3.43001 22.6116C3.62537 22.8069 3.89031 22.9167 4.16659 22.9167H5.20825C5.48452 22.9167 5.74947 22.8069 5.94483 22.6116C6.14017 22.4162 6.24992 22.1512 6.24992 21.875V20.8333H18.7499V21.875C18.7499 22.1512 18.8597 22.4162 19.055 22.6116C19.2503 22.8069 19.5153 22.9167 19.7916 22.9167H20.8333C21.1095 22.9167 21.3745 22.8069 21.5698 22.6116C21.7651 22.4162 21.8749 22.1512 21.8749 21.875V20.5448C22.191 20.3635 22.4537 20.1022 22.6365 19.7871C22.8194 19.4721 22.916 19.1143 22.9166 18.75V15.625C22.9166 14.7594 22.3885 14.0187 21.6374 13.7031L20.2124 9.42812C20.0058 8.8057 19.608 8.26426 19.0761 7.88073C18.5441 7.4972 17.9047 7.29107 17.2489 7.29166H7.75096C7.09512 7.29107 6.45576 7.4972 5.92375 7.88073C5.39174 8.26426 4.99414 8.8057 4.78742 9.42812L3.36242 13.7031C2.98356 13.8618 2.66003 14.1288 2.43245 14.4708C2.20488 14.8127 2.08339 15.2143 2.08325 15.625V18.75C2.08325 19.5187 2.50409 20.1833 3.12492 20.5448ZM5.72909 18.75C5.52383 18.7499 5.3206 18.7095 5.13098 18.6308C4.94138 18.5522 4.76911 18.437 4.62401 18.2919C4.33099 17.9986 4.16645 17.601 4.16659 17.1865C4.16672 16.7719 4.33153 16.3744 4.62475 16.0813C4.91797 15.7883 5.31559 15.6238 5.73013 15.6239C6.14467 15.6241 6.54217 15.7888 6.8352 16.0821C7.12822 16.3753 7.29276 16.7729 7.29263 17.1875C7.29249 17.6021 7.12768 17.9996 6.83446 18.2926C6.54124 18.5856 6.14363 18.7501 5.72909 18.75ZM19.2708 18.75C18.8562 18.7499 18.4587 18.5851 18.1656 18.2919C17.8726 17.9986 17.7081 17.601 17.7083 17.1865C17.7084 16.7719 17.8731 16.3744 18.1664 16.0813C18.4596 15.7883 18.8572 15.6238 19.2718 15.6239C19.6864 15.6241 20.0839 15.7888 20.3769 16.0821C20.6699 16.3753 20.8344 16.7729 20.8343 17.1875C20.8342 17.6021 20.6694 17.9996 20.3762 18.2926C20.0829 18.5856 19.6853 18.7501 19.2708 18.75ZM7.75096 9.37499H17.2478C17.4666 9.37494 17.6797 9.44373 17.8572 9.57162C18.0346 9.6995 18.1673 9.87999 18.2364 10.0875L19.3885 13.5417H5.61138L6.76242 10.0875C6.90513 9.66145 7.30304 9.37499 7.75096 9.37499Z" fill="black" fillOpacity="0.35" />
                                                        <path d="M22.9166 7.69585V5.49898L12.8291 2.13648C12.6062 2.06186 12.3645 2.06516 12.1437 2.14586L2.08325 5.80419V8.02085L12.5155 4.22711L22.9166 7.69585Z" fill="black" fillOpacity="0.35" />
                                                    </svg>
                                                    <span>{parking}</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="price-type flex justify-between">
                                            <span className="price">{price !== '—' && price !== '' && !isNaN(Number(price)) ? `€ ${Number(price).toLocaleString()}` : price}</span>
                                            <span className="feed-receive-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                                    <g clipPath={`url(#clip0_721_7733_${index})`}>
                                                        <path d="M14.4554 11.1097C14.2519 10.9062 13.9211 10.9062 13.7176 11.1097L12.5218 12.3055V1.04324C12.5218 0.75524 12.288 0.521484 12 0.521484C11.712 0.521484 11.4783 0.75524 11.4783 1.04324V13.565C11.4783 13.7757 11.6056 13.9667 11.8007 14.0471C11.8654 14.0742 11.9332 14.0867 12 14.0867C12.1357 14.0867 12.2692 14.0335 12.3684 13.9344L14.4554 11.8474C14.6588 11.644 14.6588 11.3132 14.4554 11.1097Z" fill="currentColor" />
                                                        <path d="M12.3684 13.1971L10.2815 11.1101C10.078 10.9067 9.7472 10.9067 9.54372 11.1101C9.34024 11.3136 9.34024 11.6444 9.54372 11.8479L11.6307 13.9349C11.733 14.0361 11.8665 14.0872 12.0001 14.0872C12.1337 14.0872 12.2672 14.0361 12.3684 13.9349C12.5719 13.7313 12.5719 13.4006 12.3684 13.1971Z" fill="currentColor" />
                                                        <path d="M23.3864 11.9657L19.6247 6.32255C18.9454 5.30413 17.809 4.6958 16.5861 4.6958H14.0869C13.7989 4.6958 13.5652 4.92956 13.5652 5.21756C13.5652 5.50556 13.7989 5.73931 14.0869 5.73931H16.5861C17.4594 5.73931 18.2713 6.17341 18.7565 6.9007L22.5182 12.5438C22.8052 12.9737 22.9565 13.4746 22.9565 13.9911V20.8697C22.9565 21.7327 22.2542 22.4349 21.3913 22.4349H2.60868C1.74571 22.4349 1.04346 21.7327 1.04346 20.8697V14.0683C1.04346 13.5101 1.21774 12.9768 1.56311 12.5041L4.93772 7.38274C5.616 6.35283 6.7565 5.73926 7.98779 5.73926H9.913C10.201 5.73926 10.4348 5.50551 10.4348 5.21751C10.4348 4.92951 10.2011 4.6958 9.91305 4.6958H7.98784C6.40384 4.6958 4.93777 5.4857 4.06643 6.80884L0.706451 11.9093C0.244174 12.5407 0 13.2867 0 14.0683V20.8697C0 22.3076 1.17078 23.4784 2.60868 23.4784H21.3913C22.8292 23.4784 24 22.3076 24 20.8697V13.9911C24 13.268 23.7882 12.5678 23.3864 11.9657Z" fill="currentColor" />
                                                        <path d="M22.9565 13.0435H20.3478C18.9099 13.0435 17.7392 14.2142 17.7392 15.6521C17.7392 16.5151 17.0369 17.2174 16.1739 17.2174H7.8261C6.96313 17.2174 6.26089 16.5151 6.26089 15.6521C6.26089 14.2142 5.09011 13.0435 3.65221 13.0435H1.04348C0.755484 13.0435 0.521729 13.2772 0.521729 13.5652C0.521729 13.8532 0.755484 14.0869 1.04348 14.0869H3.65216C4.51513 14.0869 5.21738 14.7892 5.21738 15.6521C5.21738 17.09 6.38816 18.2608 7.82606 18.2608H16.1739C17.6118 18.2608 18.7826 17.09 18.7826 15.6521C18.7826 14.7892 19.4849 14.0869 20.3478 14.0869H22.9565C23.2445 14.0869 23.4783 13.8532 23.4783 13.5652C23.4783 13.2772 23.2445 13.0435 22.9565 13.0435Z" fill="currentColor" />
                                                    </g>
                                                    <defs>
                                                        <clipPath id={`clip0_721_7733_${index}`}>
                                                            <rect width="24" height="24" fill="currentColor" />
                                                        </clipPath>
                                                    </defs>
                                                </svg>
                                            </span>
                                        </div>
                                        <div className="feed-card-actions">
                                            {String(listing.status) === '1' && String(listing.business_type) === '2' ? (
                                                <>
                                                    <div className="feed-action-tabs" onClick={(e) => e.stopPropagation()}>
                                                        <button
                                                            type="button"
                                                            className={`feed-action-tab ${String(listing.is_published) == '0' ? 'active' : ''}`}
                                                            onClick={() => handlePublishIndexChange('0', listing.listing_id, listing.request_id)}
                                                            disabled={isActionLoading}
                                                        >
                                                            Pending
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className={`feed-action-tab ${String(listing.is_published) == '1' ? 'active' : ''}`}
                                                            onClick={() => handlePublishIndexChange('1', listing.listing_id, listing.request_id)}
                                                            disabled={isActionLoading}
                                                        >
                                                            {stringsoflanguages.published}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className={`feed-action-tab ${String(listing.is_published) == '2' ? 'active' : ''}`}
                                                            onClick={() => handlePublishIndexChange('2', listing.listing_id, listing.request_id)}
                                                            disabled={isActionLoading}
                                                        >
                                                            {stringsoflanguages.unpublished}
                                                        </button>

                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className="feed-action-tabs" onClick={(e) => e.stopPropagation()}>
                                                        <button
                                                            type="button"
                                                            className={`feed-action-tab ${String(listing.status) == '0' ? 'active' : ''}`}
                                                            onClick={() => handleAcceptIndexChange('2', listing.listing_id, listing.request_id)}
                                                            disabled={isActionLoading}
                                                        >
                                                            Pending
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className={`feed-action-tab ${String(listing.status) == '1' ? 'active' : ''}`}
                                                            onClick={() => handleAcceptIndexChange('1', listing.listing_id, listing.request_id)}
                                                            disabled={isActionLoading}
                                                        >
                                                            {stringsoflanguages.accept}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className={`feed-action-tab ${String(listing.status) == '2' ? 'active' : ''}`}
                                                            onClick={() => handleAcceptIndexChange('0', listing.listing_id, listing.request_id)}
                                                            disabled={isActionLoading}
                                                        >
                                                            {stringsoflanguages.decline}
                                                        </button>

                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                    )}
                </div>


            </div>

            {!isMobile && (
                <div className="btn-section btn-section-gear" ref={gearMenuRef}>
                    <button
                        type="button"
                        className={`btn-primary gear-btn ${gearSpinning ? 'gear-spin' : ''}`}
                        onClick={() => {
                            setGearMenuOpen((prev) => !prev);
                            setGearSpinning(true);
                            setTimeout(() => setGearSpinning(false), 500);
                        }}
                        aria-label="Options"
                        aria-expanded={gearMenuOpen}
                    >
                        <i className="fa-solid fa-gear"></i>
                    </button>
                    {gearMenuOpen && (
                        <ul className="gear-dropdown" aria-label="Options list">
                            <li>
                                <button
                                    type="button"
                                    className="gear-dropdown-item"
                                    onClick={() => {
                                        setGearMenuOpen(false);
                                        navigate('/feed/new-available-filter');
                                    }}
                                >
                                    <i className="fa-solid fa-sliders"></i>
                                    <span>{stringsoflanguages.filter}</span>
                                </button>
                            </li>
                        </ul>
                    )}
                </div>
            )}

            {isMobile && (
                <nav className="mobile-bottom-nav liquidGlass-wrapper dock feed-recived-mobile-bottom-nav" aria-label="New Available actions">
                    <div className="liquidGlass-effect" aria-hidden="true" />
                    <div className="liquidGlass-shine" aria-hidden="true" />
                    <div className="mobile-nav-item cursor-pointer" aria-label="Filter" onClick={() => navigate('/feed/new-available-filter')}>
                        <i className="fa-solid fa-sliders"></i>
                    </div>
                </nav>
            )}


        </div>
    )
}